import { ApiError } from '@/apis'

import type { OrderStatus, PaymentMethodType } from './types'

/** 결제수단 5종 — 백엔드 명세 텍스트 */
export const PAYMENT_METHOD_TYPES = {
  CARD: 'CARD',
  ACCOUNT: 'ACCOUNT',
  KAKAOPAY: 'KAKAOPAY',
  TOSS_QUICK_ACCOUNT: 'TOSS_QUICK_ACCOUNT',
  NAVERPAY: 'NAVERPAY',
} as const satisfies Record<PaymentMethodType, PaymentMethodType>

/** PG SDK script URL */
export const TOSSPAYMENTS_V2_SDK_URL = 'https://js.tosspayments.com/v2/standard'
export const NAVERPAY_SDK_URL = 'https://nsp.pay.naver.com/sdk/js/naverpay.min.js'

/** 주문 상태 enum — apidog OAS 기준 */
export const ORDER_STATUS = {
  ORDERED: 'ORDERED',
  IN_PROGRESS: 'IN_PROGRESS',
  DELAYED: 'DELAYED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
} as const satisfies Record<OrderStatus, OrderStatus>

/**
 * 주문 취소 불가 에러 코드 — DELETE /orders/{id} 422 응답.
 *  - E422203: 수거크루 이동중 취소 불가
 *  - E422207: 22:00~22:10 시간대 취소 불가
 * 둘 다 "지금은 취소할 수 없어요" Dialog로 동일 안내한다.
 */
export const CANCEL_NOT_ALLOWED_ERROR_CODES: readonly string[] = ['E422203', 'E422207']

/** DELETE /orders 취소 불가(422) 에러인지 — "지금은 취소할 수 없어요" Dialog 분기용 */
export function isCancelNotAllowedError(error: unknown): boolean {
  return error instanceof ApiError && CANCEL_NOT_ALLOWED_ERROR_CODES.includes(error.code)
}
